import apiSlice from "./ApiSlice";

const paymentModeApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // get all delivery dates
    getAllPaymentModeData: builder.query({
      providesTags: ["payment-mode"],
      query: (body: PaginationPayloadType) => {
        return {
          url: "/payment-mode",
          method: "POST",
          body,
        };
      },
    }),

    // delete delivery date
    deletePaymentModeById: builder.mutation({
      invalidatesTags: ["payment-mode"],
      query: (id: any) => ({
        url: `/payment-mode/${id}`,
        method: "DELETE",
      }),
    }),
    // add delivery date
    addPaymentMode: builder.mutation({
      invalidatesTags: ["payment-mode"],
      query: (body) => ({
        url: `/payment-mode/add`,
        method: "POST",
        body,
      }),
    }),
    //get delivery date by Id
    getPaymentModeById: builder.query({
      providesTags: ["payment-mode"],
      query: (id: string) => {
        return {
          url: `/payment-mode/${id}`,
          method: "GET",
        };
      },
    }),


    //get Payment Modes
    getAllPaymentMode: builder.query({
      providesTags: ["payment-mode"],
      query: () => {
        return {
          url: `/payment-mode`,
          method: "GET",
        };
      },
    }),

    // update delivery date
    updatePaymentModeById: builder.mutation({
      invalidatesTags: ["payment-mode"],
      query: ({ body, id }) => ({
        url: `/payment-mode/${id}`,
        method: "PUT",
        body,
      }),
    }),

    // change status of delivery date
    changeStatusPaymentModeById: builder.mutation({
      invalidatesTags: ["payment-mode"],
      query: ({ body, id }) => ({
        url: `/payment-mode/status-change/${id}`,
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const {
  useGetAllPaymentModeDataQuery,
  useDeletePaymentModeByIdMutation,
  useAddPaymentModeMutation,
  useGetPaymentModeByIdQuery,
  useUpdatePaymentModeByIdMutation,
  useGetAllPaymentModeQuery,
  useChangeStatusPaymentModeByIdMutation,
} = paymentModeApi;
